import Vue from 'vue'
import VueRouter from 'vue-router'
import private_routes from '@/routes/private_routes.js'
import public_routes from '@/routes/public_routes.js'

Vue.use(VueRouter)

const routes = [
    ...private_routes, ...public_routes
]

const router = new VueRouter({
    routes,
    mode: 'history',
});

router.beforeEach(async (to, from, next) => {
    // 替換瀏覽器分頁上的標題文字
    document.title = to.name + ' | Optimize99管理後台'
    next()
})

export default router